module.exports = __webpack_public_path__ + "static/media/logo.a6340ed1.png";